import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a50986f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tenant-suggestion w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "fa fa-exclamation-circle",
    style: {"margin-right":"10px","display":"inline-block"}
  }),
  /*#__PURE__*/_createTextVNode(" We have found the tenant record and prefired the rest of the form for you. ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-user icon" }, null, -1))
const _hoisted_4 = { class: "text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-envelope icon" }, null, -1))
const _hoisted_6 = { class: "text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-birthday-cake icon" }, null, -1))
const _hoisted_8 = { class: "text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-phone icon" }, null, -1))
const _hoisted_10 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.tenant.first_name) + " " + _toDisplayString(_ctx.tenant.last_name), 1)
    ]),
    _createElementVNode("div", null, [
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.tenant.email), 1)
    ]),
    _createElementVNode("div", null, [
      _hoisted_7,
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$filters.formatDate(_ctx.tenant.date_of_birth)), 1)
    ]),
    _createElementVNode("div", null, [
      _hoisted_9,
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.tenant.mobile_number), 1)
    ]),
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.useInfo && _ctx.useInfo(...args))),
      href: "javascript:void(0)",
      class: "action"
    }, "Use this information instead.")
  ]))
}